<template>
  <div style="height: 100%">
    <fdc-panel
      :title="'Server-Side Pagination (Monitor > Event History data 활용)'"
      style="height: 100%;"
    >
      <brique-grid
        style="width: 100%; height: 70%;"
        id="paginationServer"
        :brique-grid-columns="columnDefs"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"

        :pagination="true"
        :brique-grid-is-view-pagination="true"
        :brique-grid-pagination-type="'server'"
        :paging-size="paging.size"
        :current-page="paging.currentPage"
        :total-page="paging.totalPage"
        :total-element-count="paging.total"
        @changed-page="changedPage"

        :brique-grid-is-view-cud-count="false"
      />
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import API from '@/views/Fdc/Apis/'
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'PaginationServer',
  components: {
    'monaco-editor': MonacoEditor
  },
  mounted () {
    this.getEqpEventHistoryList()
  },
  methods: {
    async getEqpEventHistoryList () {
      let params = {}
      let fab = []
      let eqpId = []
      let moduleId = []

      fab.push('BRIQUE')
      eqpId.push('REFLEX01')
      moduleId.push('PM01')

      params = {
        fab: fab + '',
        eqpId: eqpId + '',
        moduleId: moduleId + '',
        fromDate: '20220411000000999',
        toDate: '20220415235959999',
        page: this.paging.currentPage,
        size: this.paging.size
      }
      let data = await API.Monitor.getEqpsEvents(params)

      if (data.content.length > 0) {
        this.rowData = data.content
        this.originRowData = data.content
        this.paging.total = data.totalElements
        this.paging.totalPage = data.totalPages
        this.paging.currentPage = data.pageable.pageNumber
      } else {
        this.rowData = []
        this.originRowData = []
        this.paging.total = 0
        this.paging.totalPage = 0
        this.paging.currentPage = 0
      }
    },
    /**
     * Grid Change Page method
     * @param {*} page current page
     * @param {*} size page size
     */
    changedPage (page, size) {
      this.paging.currentPage = page
      this.getEqpEventHistoryList()
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', minWidth: 70, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_DATE'), field: 'startDt', flex: 1, type: 'dateTimeColumn', minWidth: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.END_DATE'), field: 'endDt', flex: 1, type: 'dateTimeColumn', minWidth: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_TYPE'), field: 'eventType', centered: true, flex: 1, minWidth: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', minWidth: 150, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', numeric: true, minWidth: 50, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.BATCH_ID'), field: 'batchId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.OPER_ID'), field: 'operId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), field: 'reticleId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PPID'), field: 'ppId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.DEVICE'), field: 'device', minWidth: 100, flex: 1 }
      ],

      defaultColDef: {
        minWidth: 100,
        filter: true,
        resizable: true,
        sortable: true
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid Component props 설정',
        ' */',
        '// Component props 설정',
        '` :pagination="true" `',
        '` :brique-grid-is-view-pagination="true" `',
        '` :brique-grid-pagination-type="\'server\'" `\t// Pagination Type 지정 (default는 server)',
        '` :paging-size="paging.size" `\t\t\t\t// 페이지 사이즈',
        '` :current-page="paging.currentPage" `\t\t// 현재 페이지',
        '` :total-page="paging.totalPage" `\t\t\t// 전체 페이지 수',
        '` :total-element-count="paging.total" `\t\t// 전체 행 수',
        '` @changed-page="changedPage" `\t\t\t\t// Page 변경 시의 method 지정'
      ].join('\n'),
      paging: {
        size: 100, // page per size 설정
        currentPage: 0, // 0으로 초기설정
        totalPage: 1, // 1로 초기설정
        totalElements: 1
      }
    }
  }
}
</script>
